var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightSparkles375(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 78,
    viewBox: "0 0 69 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.5532 53.854C48.5285 54.8071 50.9025 53.9783 51.8555 52.003C52.8086 50.0276 51.9798 47.6537 50.0044 46.7006C48.0291 45.7476 45.6551 46.5763 44.7021 48.5517C43.749 50.5271 44.5778 52.901 46.5532 53.854Z",
    fill: "#8E4DD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8609 27.0849L49.3044 21.9065L42.4154 21.5628L47.5938 17.0063L47.9375 10.1173L52.4942 15.2953L59.383 15.6394L54.2047 20.1959L53.8609 27.0849Z",
    fill: "#FFCC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8678 62.7355L7.31115 57.5574L0.422279 57.2134L5.60068 52.6568L5.94434 45.7679L10.501 50.946L17.3898 51.29L12.2119 55.8465L11.8678 62.7355Z",
    fill: "#00A98F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightSparkles375);
export default __webpack_public_path__ + "static/media/rightSparkles375.86033b29cca65775aaff086be3693aa1.svg";
export { ForwardRef as ReactComponent };